import React, {useState} from "react";
import "./CloverApplication.css"; 
import { rootUrl } from "config/setting";
import axios from "axios";
import { FormattedMessage } from "react-intl";

export default function Index() {
    const [isSent, setIsSent] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault(); 
        const { firstname, lastname, email, phone, title} =
        e.target.elements;
        let details = {
            "first-name": firstname.value,
            "last-name": lastname.value,
            "email": email.value,
            "phone": phone.value,
            "title": title.value,
        };
        const form = new FormData();
        for (const field in details) {
            form.append(field, details[field]);
          }
          axios
            .post(
                // `${rootUrl}/wp-json/contact-form-7/v1/contact-forms/450/feedback`,
                `${rootUrl}/wp-json/contact-form-7/v1/contact-forms/461/feedback`,

                form,
                { headers: { "content-type": "multipart/form-data" } }
            )
            .then(function (response) {
                console.log(response);
                setIsSent(true);
            })
            .catch(function (error) {
            console.log(error);
            });
    }

    return (
        <div className="application_container">
            {!isSent ? (
                <>
                <div className="application_form_container">
                <form onSubmit={handleSubmit}>
                    <div className="application_form_container_inputs">
                    <h2><FormattedMessage id={"lets_start"}/></h2>
                    <p><FormattedMessage id={"speaking_with"}/></p>
                    <input
                        type="text"
                        placeholder="First Name *"
                        id="firstname"
                        name="first-name"
                    />
                    <input
                        type="text"
                        placeholder="Last Name *"
                        id="lastname"
                        name="last-name"
                    />
                    <input
                        type="text"
                        placeholder="Email * (The best email to reach you personally.)"
                        id="email"
                        name="email"
                    />
                    <input
                        type="text"
                        placeholder="Phone * (The best number to reach you personally.)"
                        id="phone"
                        name="phone"
                    />
                    <input
                        type="text"
                        placeholder="Title (Your position/role in the business.)"
                        id="title"
                        name="title"
                    />
                    <button
                        id="subBtn"
                        className="submit_btn"
                        type="submit"
                    >
                        Submit
                    </button>
                    </div>
                </form>
                </div>
            </>) : (
                <div className="thanks-message col">
                <div className="text-wrapper">
                  <h2>Form Submitted.</h2>
                  <p>Thank you for your interest in Goopter solutions! We’ve received your request and will get back to you in 24 hours.</p>
                </div>
              </div>
            ) }
            
        </div>
    ); 
}

